
/**
 * 上传图片
 * @param payload
 */
export let upload = process.env.VUE_APP_API_BASE_URL + '/storage/editor_image';